import { createVanIconComponent } from "./van"

const Stop = createVanIconComponent("stop")
export default Stop
